import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { ICON } from 'resources/constants';

import { Wrapper, StreakCircle, TextWrapper, Title, Text } from './elements';

type Props = {
  readonly onStreakClicked: () => void;
  readonly data: {
    id: number;
    color: string;
    borderColor: string;
    borderWidth: number;
  }[];
  readonly title: string;
  readonly text: string;
};

const deps = {
  isLoadingStats: state.challenge.isLoading.dailyUserStats,
};

export function StreakCard({
  isLoadingStats,
  onStreakClicked,
  data,
  title,
  text,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  if (isLoadingStats) {
    return (
      <Wrapper onClick={null}>
        <StreakCircle
          size={'small'}
          icon={ICON.flame}
          iconColor={'#FF7043'}
          data={[]}
        />
        <TextWrapper>
          <Title>{'-'}</Title>
          <Text>{'-'}</Text>
        </TextWrapper>
      </Wrapper>
    );
  }

  return (
    <Wrapper onClick={onStreakClicked}>
      <StreakCircle
        size={'small'}
        icon={ICON.flame}
        iconColor={'#FF7043'}
        data={data}
      />
      <TextWrapper>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </TextWrapper>
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, StreakCard);
